/**
 * @file
 * Behaviors for the Slider.
 */

(($, Drupal) => {
  'use strict';

  /**
   * Setup and attach the Slider.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.Slider = {
    attach(context, drupalSettings) {
      once('camcslider', '.slider__slide-wrapper', context).forEach((slide) => {
        
        const autoplaySpeed = parseInt(drupalSettings.slider.interval);
        const autoplay = autoplaySpeed > 0;

        let $arrows = $(slide).siblings('.slider__arrows');
        $arrows.css({
          top: ($(slide).width() * (2 / 3)) / 2
        });

        window.addEventListener('resize', () => {
          $(slide).siblings('.slider__arrows').css({
            top: ($(slide).width() * (2 / 3)) / 2
          })
        });

        if ($(slide).find('.slider__slide').length > 1) {
          $(slide).slick({
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            appendArrows: $arrows,
            appendDots: $(slide).siblings('.slider__dots'),
            dots: true,
          });
        }
      });
    }
  };
})(jQuery, Drupal);
